import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PoInputComponent, PoModule } from '@po-ui/ng-components';
import { PoPageDynamicEditModule } from '@po-ui/ng-templates';
import { EmpresaEditComponent } from './empresa-edit/empresa-edit.component';
import { EmpresaComponent } from './empresa.component';



@NgModule({
  declarations: [EmpresaComponent, EmpresaEditComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    PoModule,
    PoPageDynamicEditModule,
  ]
})
export class EmpresaModule { }
